export default __webpack_public_path__ + "static/media/card_template.b26d6b6b.png";